import { render } from "./ServerDataTable.vue?vue&type=template&id=e4de9340&scoped=true"
import script from "./ServerDataTable.vue?vue&type=script&lang=js"
export * from "./ServerDataTable.vue?vue&type=script&lang=js"

import "./ServerDataTable.vue?vue&type=style&index=0&id=e4de9340&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4de9340"]])

export default __exports__